import {
  IN_APP_NOTIFICATIONS_MARK_ALL_READ,
  IN_APP_NOTIFICATIONS_MARK_READ,
  IN_APP_NOTIFICATIONS_MERGE,
  IN_APP_NOTIFICATIONS_PUSH,
} from "../definitions/inAppNotificationConstants";
import { InAppNotification } from "../../types/inAppNotification";

export interface MergeInAppNotificationsAction {
  type: typeof IN_APP_NOTIFICATIONS_MERGE;
  payload: {
    notifications: InAppNotification[];
    unreadCount: number;
  };
}

export interface PushInAppNotificationAction {
  type: typeof IN_APP_NOTIFICATIONS_PUSH;
  payload: { notification: InAppNotification };
}

export interface MarkInAppNotificationReadAction {
  type: typeof IN_APP_NOTIFICATIONS_MARK_READ;
  payload: { id: number };
}

export interface MarkAllInAppNotificationsReadAction {
  type: typeof IN_APP_NOTIFICATIONS_MARK_ALL_READ;
}

export const mergeInAppNotifications = (
  notifications: InAppNotification[],
  unreadCount: number
): MergeInAppNotificationsAction => ({
  type: IN_APP_NOTIFICATIONS_MERGE,
  payload: { notifications, unreadCount },
});

export const pushInAppNotification = (
  notification: InAppNotification
): PushInAppNotificationAction => ({
  type: IN_APP_NOTIFICATIONS_PUSH,
  payload: { notification },
});

export const markInAppNotificationRead = (
  id: number
): MarkInAppNotificationReadAction => ({
  type: IN_APP_NOTIFICATIONS_MARK_READ,
  payload: { id },
});

export const markAllInAppNotificationsRead =
  (): MarkAllInAppNotificationsReadAction => ({
    type: IN_APP_NOTIFICATIONS_MARK_ALL_READ,
  });
